


export default function Type4BillingGrid({ products, formatPrice, invoiceSetting, onItemClick, type }) {
  return (
    <div className="w-full">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 mt-2 border border-t-2 border-[#E7EBF4] rounded-xl p-3">
        {products.map((item, index) => {
          let discountValue = 0;
          const isPercentage = item?.discount_type === "Percentage" || item?.discount_type === "2";

          if (isPercentage && item?.discount) {
            discountValue =
              type === "purchase" || type === "wholesale"
                ? 0
                : (item.retails_price || 0) * (item.discount / 100);
          } else {
            discountValue =
              type === "purchase" || type === "wholesale" ? 0 : Number(item?.discount || 0);
          }

          const finalPrice =
            type === "purchase"
              ? item?.purchase_price
              : type === "wholesale"
              ? item?.wholesale_price
              : (item?.retails_price || 0) - discountValue;

          const currency = invoiceSetting?.currency_info?.code || "BDT";

          return (
            <button
              key={item?.id ?? index}
              onClick={() => onItemClick(item)}
              className="relative group text-left bg-white border-2 border-green-500 rounded-xl p-3 hover:shadow-md transition focus:outline-none focus:ring-2 focus:ring-blue-200"
            >
              {/* Name (truncated) */}
              <div className="font-nunito text-[14px] font-semibold">
                {item?.name}
              </div>

              {/* Tooltip (full name) */}
              <div className="pointer-events-none absolute z-50 left-1/2 -translate-x-1/2 -top-2 -translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-150 bg-gray-900 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-normal break-words max-w-[280px]">
                {item?.name}
                <div className="absolute left-1/2 top-full -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
              </div>

              <div className="mt-1 flex items-baseline gap-2">
                <span className="text-[13px] font-semibold">
                  {formatPrice(finalPrice)}
                </span>
                <span className="text-xs">{currency}</span>

                {discountValue > 0 && type === "billing" && (
                  <span className="text-xs text-red-500 line-through">
                    {formatPrice(item?.retails_price)} {currency}
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}